import { Shipment, ShipmentFactory } from '@library/common/models';

export interface Template {
   id: number;

   name: string;
   owner_name: string;
   last_updated: string;

   shared: boolean;
   owned: boolean;

   data?: Shipment<any, any>;
   description?: string;
}

export class Template implements Template {
   constructor( t?: any ) {
      this.id = t && t['id'] || null;
      this.name = t && t['name'];
      this.owner_name = t && t['owner_name'];
      this.last_updated = t && t['last_updated'];

      this.shared = t && t['shared'] || false;
      this.owned = t && t['owned'] || false;

      this.data = ShipmentFactory.load( t && t['data'] || {} );
      this.description = t && t['description'] || null;
   }
}
